import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from 'axios';
import Select from 'react-select'
import $ from 'jquery';
const Viewuser = (props) => {

    const [items, setitems] = useState([]);
    const url = process.env.REACT_APP_APIURL + "User/GetUsers?companyid=" + props.companyid;
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
          
        }, 100)

    }, []);
    useEffect(() => {
        $('#example3').DataTable();
    }, [items]);

    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result => {
            setitems(result)
           // console.log(result)
        });
    }
     async function deletedata(id) {
       //  const urldelete = process.env.REACT_APP_APIURL + 'agent/DeleteAgent?Agentid=' + id;
         const urldelete = process.env.REACT_APP_APIURL + "user/ActiveUser?userid=" + id;
         let res = await axios.post(urldelete);
         debugger;
         if (res.status == 200) {
             swal({
                 title: "Update Successfully",
                 icon: "success"
             })
             populatedata();

         }
    }

    async function deletedatas(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'user/DeleteUser?userid=' + id;
       // const urldelete = process.env.REACT_APP_APIURL + "user/ActiveUser?userid=" + id;
        let res = await axios.post(urldelete);
        debugger;
        if (res.status == 200) {
            swal({
                title: "Delete Successfully",
                icon: "success"
            })
            populatedata();

        }
    }

    async function handleEdit(id) {
        const agenturl = process.env.REACT_APP_APIURL + "User/Getuser?UserId=" + id + "&companyid=" + props.companyid;
        await fetch(agenturl).then(res => res.json()).then(r => {
            setupateitems({
                ...upateitems, id: r.id, f_name: r.f_name, l_name: r.l_name, username: r.username, password: r.password, email: r.email, phone: r.phone, discount: r.discount, company_id: r.company_id, usertypeid: r.usertypeid, logo: r.logo, minlogo: r.minlogo, status: r.status
            })
            settypevalue({ value: r.usertypeid , label: r.userTypename})
        }
        );
        $("#myModal").modal('show');
    }
async function handleDelete(id) {
        debugger;
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete)
            {
                debugger;
                deletedata(id);
              
            } else {
                swal("0 Rows Effected");
            }
        });
    }

    async function handleDeletes(id) {
        debugger;
        swal({
            title: "Are you sure?",
              text: "Once deleted, you will not be able to recover this User!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                debugger;
                deletedatas(id);

            } else {
                swal("0 Rows Effected");
            }
        });
    }
    //////Update Agent///////////////////////////////////////
    /////////////////////////////////////////////////////////
    const [upateitems, setupateitems] = useState({ id: "", f_name: "", l_name: "", username: "", password: "", email: "", phone: "", discount: 0, company_id: props.companyid, usertypeid: "", logo: "", minlogo: "", status: ""  })
    const [type, settype] = useState([])
    const [typevalue, settypevalue] = useState();
    useEffect(() => {
        fetchUsertype();
    }, [])
    async function fetchUsertype() {
        var res = await axios.get(process.env.REACT_APP_APIURL + "User/GetUsertypes")

        var type = [];
        res.data.map((u) => {
            type.push({ value: u.id, label: u.name });
        })
        settype(type)
    }
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupateitems({ ...upateitems, [name]: value })
    }
    const refresh = () => {
        settypevalue(null)
        setupateitems({ id: "", f_name: "", l_name: "", username: "", password: "", email: "", phone: "", discount: 0, company_id: props.companyid, usertypeid: "", logo: "", minlogo: "", status: ""  });
        populatedata()
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "User/UpdateUser";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                $("#myModal").modal('hide');
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (upateitems.usertypeid === "") {
            swal({
                title: "Usertype Required!",
                icon: "error"
            })
            return;
        }
        upateitems.company_id = props.companyid
        savemethod(upateitems);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Users List</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Fisrt Name</th>
                                        <th>Last Name</th>
                                        <th>Username</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Discount</th>
                                        <th>User Type</th>
                                        <th>Action</th>
                                        <th>Active/Deactive</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>
                                        item.status === true ? (
                                            <tr key={item.id}>
                                                <td>{item.f_name}</td>
                                                <td>{item.l_name}</td>
                                                <td>{item.username}</td>
                                                <td>{item.email}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.discount}</td>
                                                <td>{item.userTypename}</td>
                                                <td>
                                                    <span className="d-flex">
                                                        <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                            onClick={() => handleEdit(item.id)}>
                                                            <i className="fas fa-pencil-alt"></i>
                                                        </button>
                                                        <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                            onClick={(id) => handleDeletes(item.id)}>
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="checkbox-group" id="checkboxes">
                                                        <ul>
                                                            <li>

                                                                <button href="#" className="btn btn-light shadow sharp me-2"
                                                                    onClick={() => handleDelete(item.id)}>
                                                                    Active
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) :
                                            <tr key={item.id}>
                                                <td>{item.f_name}</td>
                                                <td>{item.l_name}</td>
                                                <td>{item.username}</td>
                                                <td>{item.email}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.discount}</td>
                                                <td>{item.userTypename}</td>
                                                <td>
                                                    <span className="d-flex">
                                                        <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                            onClick={() => handleEdit(item.id)}>
                                                            <i className="fas fa-pencil-alt"></i>
                                                        </button>
                                                        {/*<button href="#" className="btn btn-danger shadow btn-xs sharp"*/}
                                                        {/*    onClick={(id) => handleDelete(item.agent_ID)}>*/}
                                                        {/*    <i className="fa fa-trash"></i>*/}
                                                        {/*</button>*/}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="checkbox-group" id="checkboxes">
                                                        <ul>
                                                            <li>

                                                                <button href="#" className="btn btn-dark shadow sharp me-2"
                                                                    onClick={() => handleDelete(item.id)}>
                                                                    deactive
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-3 mt-5 text-center mx-auto">Add User</h3>
                            </div>
                            <div className="card-body">

                                <div className="basic-form">
                                    <form action="" onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">First Name *</label>
                                                <input type="text" className="form-control" name="f_name" autoComplete="off" value={upateitems.f_name} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Last Name</label>
                                                <input type="text" className="form-control" name="l_name" autoComplete="off" value={upateitems.l_name} onChange={handleInput} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Username *</label>
                                                <input type="text" className="form-control" name="username" autoComplete="off" value={upateitems.username} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Passoword *</label>
                                                <input type="text" className="form-control" name="password" autoComplete="off" value={upateitems.password} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Email</label>
                                                <input type="email" className="form-control" name="email" autoComplete="off" value={upateitems.email} onChange={handleInput} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Phone</label>
                                                <input type="number" className="form-control" name="phone" autoComplete="off" value={upateitems.phone} onChange={handleInput} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label>Discount(%)</label>
                                                <input type="number" className="form-control" name="discount" autoComplete="off" value={upateitems.discount} onChange={handleInput} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label>User Type *</label>
                                                <Select options={type} value={typevalue} onChange={(e) => { settypevalue(e); setupateitems({ ...upateitems, usertypeid: e.value }) }} />
                                            </div>
                                        </div>
                                        <button type="submit" className="d-flex mx-auto btn btn-primary">Save</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Viewuser;